'use client';
import { useTranslation } from '@root/src/i18n/client';

export default function TeaExperienceHero() {
  const { t } = useTranslation('common');

  return (
    <section className="relative w-full bg-gradient-to-b from-[#F7F1E6] to-[#FBF7F0] py-12 md:py-18">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 lg:px-8">
        <div className="flex flex-col gap-6 text-center">
<span className="text-sm uppercase tracking-[0.15em] text-[#7F6B48] font-semibold md:mb-4 lg:mt-20">
            {t('lytra.expHeroLabel')}
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#223A27]">
            {t('lytra.expHeroTitle')}
          </h1>
          <p className="mx-auto max-w-3xl text-base md:text-lg text-[#5C5A52] leading-relaxed">
            {t('lytra.expHeroDesc')}
          </p>
        </div>
      </div>
    </section>
  );
}
